import { apiEndpoints } from "@/services/api/api";

export const accountInfoAction = async ({ request }: { request: Request }) => {
  const data = await request.json();
  try {
    const result = await apiEndpoints.profileChanger(data);
    return result;
  } catch (err) {
    throw err;
  }
};
